module.exports = __webpack_public_path__ + "img/1_003.5142daac.webp";